import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  USER_ROLE_ADMIN,
} from 'common/userRoles';

import {
  DATA_TABLE_VIEW_ID_LEASES_ALL,
  DATA_TABLE_VIEW_ID_LEASES_SIGNED_PAST_START_DATE,
  DATA_TABLE_VIEW_ID_LEASES_MISSING_MERCHANT,
} from 'common/dataTableConstants';

import { SCREEN_ID_ADMIN_FINANCE_LEASES } from 'client/constants/screenIds';
import allowedRoles from 'client/helpers/allowedRoles';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';

import SrH1 from 'client/components/SrH1';
import SrPage from 'client/components/SrPage';
import SrDataTableLeases from 'client/components/financeAdmin/SrDataTableLeases';

const LEASES_DASHBOARD_SHORT_ID_ALL = 'all';
const LEASES_DASHBOARD_SHORT_ID_SIGNED_PAST_START_DATE = 'past-start-date';
const LEASES_DASHBOARD_SHORT_ID_MISSING_MERCHANT = 'missing-merchant';

const leasesDashboardShortIdToViewIdMapping = {
  [LEASES_DASHBOARD_SHORT_ID_ALL]: DATA_TABLE_VIEW_ID_LEASES_ALL,
  [LEASES_DASHBOARD_SHORT_ID_SIGNED_PAST_START_DATE]: DATA_TABLE_VIEW_ID_LEASES_SIGNED_PAST_START_DATE,
  [LEASES_DASHBOARD_SHORT_ID_MISSING_MERCHANT]: DATA_TABLE_VIEW_ID_LEASES_MISSING_MERCHANT,
};

@withTransitionHook
@allowedRoles({
  roles: [
    USER_ROLE_ADMIN,
  ],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
@withScreenId(SCREEN_ID_ADMIN_FINANCE_LEASES)
@withScrollToTop
class FinancesLeasesPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Finances - Leases | Sunroom Rentals',
  })

  static propTypes = {
    match: PropTypes.object.isRequired,
  }

  render() {
    const { match: { params: { leaseViewShortId } } } = this.props;
    return (
      <SrPage
        navbarProps={{
          redirectLogoTo: '/admin',
          backButtonLink: '/admin',
        }}
      >
        <div className='width-90'>
          <SrH1>leases</SrH1>
          <SrDataTableLeases
            viewId={leasesDashboardShortIdToViewIdMapping[leaseViewShortId]}
          />
        </div>
      </SrPage>
    );
  }
}

FinancesLeasesPage.displayName = 'FinancesLeasesPage';

export default FinancesLeasesPage;
